import React from 'react';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import customTheme from 'styles/theme';
import {getMuiV4Theme} from 'utils/css/themeUtils';

/**
 * Sidebar Toggler
 */
class SidebarToggler extends React.Component {
  /**
   * Handle touch
   */
  handleTouch = () => {
    if (this.props.sidebarOpen === false) {
      // handle opening of sidebar
      this.props.SidebarActions.open();
    } else {
      // handle closing of sidebar
      this.props.SidebarActions.close();
    }
  };

  /**
   * checks the page url to decide if the component should be visible
   */
  shouldBeVisible() {
    return window.location.pathname.indexOf('/calls/') === 0;
  }

  render() {
    if (this.shouldBeVisible() === false) {
      return null;
    }
    // set icon depending of 'sidebarOpen'
    let icon = <ArrowBackIcon color={getMuiV4Theme().palette.primary.main} />;
    if (this.props.sidebarOpen === false) {
      icon = <MenuIcon color={customTheme.palette.darkGrey} />;
    }

    return (
      <div className="hamburger" onClick={this.handleTouch}>
        {icon}
      </div>
    );
  }
}

SidebarToggler.displayName = 'SidebarToggler';
export default SidebarToggler;
